import CustomLoader from "../../ui/CustomLoader/CustomLoader";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { SuccessView } from "./result/SuccessView";
import { FailedView } from "./result/FailedView";
import { ProcessingView } from "./result/ProcessingView";

export function Step4Result({
  transactionId,
  status,
  createdDate,
  amount,
  transactionFee,
  totalDeducted,
  newBalance,
  remarks,
  isLoadingDisbursement,
  isDisbursementError,
  refetchDisbursement,
  onNewWithdrawal,
  onViewTransactions,
}) {
  if (!transactionId) {
    return (
      <FailedView
        remarks={remarks ?? "Unable to process withdrawal."}
        onNewWithdrawal={onNewWithdrawal}
      />
    );
  }

  if (!status && isLoadingDisbursement) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CustomLoader
          type="oval"
          color="primary"
          size="md"
          text="Fetching transaction details..."
          textPosition="center"
          textColor="text-primary-500"
        />
      </div>
    );
  }

  if (!status && isDisbursementError) {
    return (
      <div className="flex flex-col items-center gap-4 py-8">
        <p className="text-sm text-gray-600 text-center">
          Unable to load transaction details.
        </p>
        <CustomButton color="primary" radius="md" onClick={refetchDisbursement}>
          Retry
        </CustomButton>
      </div>
    );
  }

  if (status === "SUCCESS") {
    return (
      <SuccessView
        amount={amount}
        transactionId={transactionId}
        createdDate={createdDate}
        transactionFee={transactionFee}
        totalDeducted={totalDeducted}
        newBalance={newBalance}
        onNewWithdrawal={onNewWithdrawal}
        onViewTransactions={onViewTransactions}
      />
    );
  }

  if (status === "FAILED") {
    return (
      <FailedView
        amount={amount}
        transactionId={transactionId}
        createdDate={createdDate}
        transactionFee={transactionFee}
        newBalance={newBalance}
        remarks={remarks}
        onNewWithdrawal={onNewWithdrawal}
      />
    );
  }

  return (
    <ProcessingView
      amount={amount}
      transactionId={transactionId}
      createdDate={createdDate}
      transactionFee={transactionFee}
      totalDeducted={totalDeducted}
      newBalance={newBalance}
      onViewTransactions={onViewTransactions}
    />
  );
}
